var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 0C18.7673 0 16.5421 0.922179 14.8695 2.59613L2.59676 14.8688C0.922818 16.5434 0 18.7693 0 21.1364C0 26.0236 3.97636 30 8.86365 30C11.2327 30 13.4579 29.0778 15.1305 27.4039L27.4032 15.1318C29.0772 13.4572 30 11.2313 30 8.86358C29.9999 3.97636 26.0236 0 21.1364 0ZM14.1664 26.4397C12.7508 27.856 10.8678 28.6363 8.86365 28.6363C4.72877 28.6363 1.36368 25.2719 1.36368 21.1364C1.36368 19.1335 2.14402 17.2499 3.56094 15.8329L9.21521 10.1787L19.8208 20.7856L14.1664 26.4397ZM26.4391 14.1677L20.7849 19.8214L10.1793 9.2145L15.8336 3.56024C17.2492 2.14402 19.1321 1.36361 21.1363 1.36361C25.2712 1.36361 28.6363 4.72813 28.6363 8.86365C28.6363 10.8671 27.856 12.7508 26.4391 14.1677Z",
    fill: "#060200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61596 12.7076L4.52506 16.7978C3.36516 17.957 2.72729 19.4978 2.72729 21.1371C2.72729 21.514 3.03226 21.8189 3.40913 21.8189C3.78601 21.8189 4.09097 21.514 4.09097 21.1371C4.09097 19.8626 4.5877 18.6635 5.48923 17.762L9.58013 13.6717C9.84649 13.4053 9.84649 12.9739 9.58013 12.7076C9.31371 12.4412 8.88225 12.4412 8.61596 12.7076Z",
    fill: "#060200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/Tablet-icon.b0150a53819d45b291cf8e8c789fb581.svg";
export { ForwardRef as ReactComponent };